/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfPaginatedListOfGetActiveShortLinksWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-active-short-links-with-pagination-dto';
import { CustomResultOfPaginatedListOfGetDescendantShortLinksWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-descendant-short-links-with-pagination-dto';
import { CustomResultOfPaginatedListOfGetShortLinksWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-short-links-with-pagination-dto';
import { CustomResultOfString } from '../models/custom-result-of-string';
import { shortLinksCreateGet } from '../fn/short-links/short-links-create-get';
import { ShortLinksCreateGet$Params } from '../fn/short-links/short-links-create-get';
import { shortLinksCreatePost } from '../fn/short-links/short-links-create-post';
import { ShortLinksCreatePost$Params } from '../fn/short-links/short-links-create-post';
import { shortLinksGetActiveShortLinksWithPagination } from '../fn/short-links/short-links-get-active-short-links-with-pagination';
import { ShortLinksGetActiveShortLinksWithPagination$Params } from '../fn/short-links/short-links-get-active-short-links-with-pagination';
import { shortLinksGetDescendantShortLinksWithPagination } from '../fn/short-links/short-links-get-descendant-short-links-with-pagination';
import { ShortLinksGetDescendantShortLinksWithPagination$Params } from '../fn/short-links/short-links-get-descendant-short-links-with-pagination';
import { shortLinksGetShortLinkReport } from '../fn/short-links/short-links-get-short-link-report';
import { ShortLinksGetShortLinkReport$Params } from '../fn/short-links/short-links-get-short-link-report';
import { shortLinksGetShortLinksAudit } from '../fn/short-links/short-links-get-short-links-audit';
import { ShortLinksGetShortLinksAudit$Params } from '../fn/short-links/short-links-get-short-links-audit';
import { shortLinksGetShortLinksWithPagination } from '../fn/short-links/short-links-get-short-links-with-pagination';
import { ShortLinksGetShortLinksWithPagination$Params } from '../fn/short-links/short-links-get-short-links-with-pagination';
import { shortLinksUpdateShortLinkIsActive } from '../fn/short-links/short-links-update-short-link-is-active';
import { ShortLinksUpdateShortLinkIsActive$Params } from '../fn/short-links/short-links-update-short-link-is-active';

@Injectable({ providedIn: 'root' })
export class ShortLinksService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `shortLinksGetActiveShortLinksWithPagination()` */
  static readonly ShortLinksGetActiveShortLinksWithPaginationPath = '/ShortLinks/GetActiveShortLinksWithPagination';

  /**
   * لیست لینک های کوتاه ی فعال سازمان با صفحه بندی برای استفاده در پیامک.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shortLinksGetActiveShortLinksWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shortLinksGetActiveShortLinksWithPagination$Response(params: ShortLinksGetActiveShortLinksWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetActiveShortLinksWithPaginationDto>> {
    return shortLinksGetActiveShortLinksWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * لیست لینک های کوتاه ی فعال سازمان با صفحه بندی برای استفاده در پیامک.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shortLinksGetActiveShortLinksWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shortLinksGetActiveShortLinksWithPagination(params: ShortLinksGetActiveShortLinksWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetActiveShortLinksWithPaginationDto> {
    return this.shortLinksGetActiveShortLinksWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetActiveShortLinksWithPaginationDto>): CustomResultOfPaginatedListOfGetActiveShortLinksWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `shortLinksGetDescendantShortLinksWithPagination()` */
  static readonly ShortLinksGetDescendantShortLinksWithPaginationPath = '/ShortLinks/GetDescendantShortLinksWithPagination';

  /**
   * لیست لینک های کوتاه فرزندان با صفحه بندی برای فعال یا غیر فعال کردن.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shortLinksGetDescendantShortLinksWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shortLinksGetDescendantShortLinksWithPagination$Response(params: ShortLinksGetDescendantShortLinksWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetDescendantShortLinksWithPaginationDto>> {
    return shortLinksGetDescendantShortLinksWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * لیست لینک های کوتاه فرزندان با صفحه بندی برای فعال یا غیر فعال کردن.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shortLinksGetDescendantShortLinksWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shortLinksGetDescendantShortLinksWithPagination(params: ShortLinksGetDescendantShortLinksWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetDescendantShortLinksWithPaginationDto> {
    return this.shortLinksGetDescendantShortLinksWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetDescendantShortLinksWithPaginationDto>): CustomResultOfPaginatedListOfGetDescendantShortLinksWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `shortLinksUpdateShortLinkIsActive()` */
  static readonly ShortLinksUpdateShortLinkIsActivePath = '/ShortLinks/UpdateShortLinkIsActive';

  /**
   * به روز رسانی وضعیت فعال بودن لینک کوتاه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shortLinksUpdateShortLinkIsActive()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shortLinksUpdateShortLinkIsActive$Response(params: ShortLinksUpdateShortLinkIsActive$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return shortLinksUpdateShortLinkIsActive(this.http, this.rootUrl, params, context);
  }

  /**
   * به روز رسانی وضعیت فعال بودن لینک کوتاه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shortLinksUpdateShortLinkIsActive$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shortLinksUpdateShortLinkIsActive(params: ShortLinksUpdateShortLinkIsActive$Params, context?: HttpContext): Observable<CustomResult> {
    return this.shortLinksUpdateShortLinkIsActive$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `shortLinksGetShortLinksAudit()` */
  static readonly ShortLinksGetShortLinksAuditPath = '/ShortLinks/GetShortLinksAudit';

  /**
   * لاگ ها فقط دسترسی سوپر ادمین.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shortLinksGetShortLinksAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shortLinksGetShortLinksAudit$Response(params: ShortLinksGetShortLinksAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return shortLinksGetShortLinksAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * لاگ ها فقط دسترسی سوپر ادمین.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shortLinksGetShortLinksAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shortLinksGetShortLinksAudit(params: ShortLinksGetShortLinksAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.shortLinksGetShortLinksAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `shortLinksCreateGet()` */
  static readonly ShortLinksCreateGetPath = '/ShortLinks/Create';

  /**
   * برای درسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shortLinksCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  shortLinksCreateGet$Response(params?: ShortLinksCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return shortLinksCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * برای درسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shortLinksCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shortLinksCreateGet(params?: ShortLinksCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.shortLinksCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `shortLinksCreatePost()` */
  static readonly ShortLinksCreatePostPath = '/ShortLinks/Create';

  /**
   * ساخت لینک کوتاه با لینک داده شده.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shortLinksCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shortLinksCreatePost$Response(params: ShortLinksCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return shortLinksCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * ساخت لینک کوتاه با لینک داده شده.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shortLinksCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shortLinksCreatePost(params: ShortLinksCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.shortLinksCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `shortLinksGetShortLinksWithPagination()` */
  static readonly ShortLinksGetShortLinksWithPaginationPath = '/ShortLinks/GetShortLinksWithPagination';

  /**
   * لیست لینک های کوتاه سازمان با صفحه بندی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shortLinksGetShortLinksWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shortLinksGetShortLinksWithPagination$Response(params: ShortLinksGetShortLinksWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetShortLinksWithPaginationDto>> {
    return shortLinksGetShortLinksWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * لیست لینک های کوتاه سازمان با صفحه بندی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shortLinksGetShortLinksWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shortLinksGetShortLinksWithPagination(params: ShortLinksGetShortLinksWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetShortLinksWithPaginationDto> {
    return this.shortLinksGetShortLinksWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetShortLinksWithPaginationDto>): CustomResultOfPaginatedListOfGetShortLinksWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `shortLinksGetShortLinkReport()` */
  static readonly ShortLinksGetShortLinkReportPath = '/ShortLinks/GetShortLinkReport';

  /**
   * دریافت آمار لینک کوتاه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shortLinksGetShortLinkReport()` instead.
   *
   * This method doesn't expect any request body.
   */
  shortLinksGetShortLinkReport$Response(params?: ShortLinksGetShortLinkReport$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfString>> {
    return shortLinksGetShortLinkReport(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آمار لینک کوتاه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shortLinksGetShortLinkReport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shortLinksGetShortLinkReport(params?: ShortLinksGetShortLinkReport$Params, context?: HttpContext): Observable<CustomResultOfString> {
    return this.shortLinksGetShortLinkReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfString>): CustomResultOfString => r.body)
    );
  }

}
